import { storage } from '@/components/Storage.js';
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { user } from '@/components/User.js';
import { setCurrentDateTime } from '@/utils.js';{}

export const server = {
    pingIntervalTimerId: null,
    initPing: function () {
        var self = this;

        if (!self.pingIntervalTimerId) {
            self.pingIntervalTimerId = interval.make(function() {
                m.request({
                    method: 'POST',
                    url: '/api/ping',
                    background: true,
                    extract(xhr) {
                        const statusErr = [401, 403]
                        const obj = xhr.response
                        return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
                    }
                }).then(function (response) {
                    server.setOnline();
                    setCurrentDateTime(response.currentTime);
                }, function (err) {
                    server.setOffline(err);
                });
            }, storage.config.pingFrequency * 1000);
        }
    },
    setOnline: function () {
        cache.sync();
        storage.online = true;
        document.dispatchEvent(new CustomEvent('onlineChange', {
            detail: {online: true}
        }));
    },
    setOffline: function (err) {
        storage.online = false;
        document.dispatchEvent(new CustomEvent('onlineChange', {
            detail: {online: false}
        }));
        if ([401, 403].includes(err)) {
            user.destroy()
            if (m.route() !== '/login') {
                window.location.replace('/login')
            }
        }
    },
    getClientTime: function () {
        return document.querySelector('#ts').innerText
    }
};
